import * as React from 'react';
import { observer } from 'mobx-react';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import ColorScheme from 'owa-color-utils/lib/ColorScheme';
import EnhancedLocation from 'owa-service/lib/contract/EnhancedLocation';
import { TxpObject } from 'txp-data';
import Txp from './Txp';
import OwaTxpStyle from '../store/viewSchema/OwaTxpStyle';
import { createCalendarPeekStyle } from '../utils/view/createTxpStyle';
import createTxpStrings from '../utils/view/createTxpStrings';
import createCalendarPeekTxpConfiguration from '../utils/view/createCalendarPeekTxpConfiguration';
import getTxpLocation from '../utils/view/getTxpLocation';
import getOriginFromTxpObject from '../utils/view/getOriginFromTxpObject';
import populateCardViewedDatapoint from '../utils/telemetry/populateCardViewedDatapoint';
import TxpDatapoint from 'txp-data/lib/schema/configSchema/TxpDatapoint';
import TxpConfiguration from 'txp-data/lib/schema/configSchema/TxpConfiguration';
import getInternetMessageIdFromTxpObject from '../utils/view/getInternetMessageIdFromTxpObject';

let styles = require('./Txp.scss');

export interface TxpPeekWrapperProps extends React.HTMLProps<HTMLDivElement> {
    entityNamesMap: number;
    txpObject: TxpObject;
    colorScheme?: ColorScheme;
    txpLocation: EnhancedLocation;

    // Callbacks hooks for logging data points
    datapointLogger?: (
        txpDatapoint: TxpDatapoint,
        datapointName: string,
        internetMessageId?: string
    ) => void;

    // Callback to show the mail Popout from calendar
    onViewInMailClicked?: () => void;
    isInvoiceSupported?: boolean;
    isServiceReservationSupported?: boolean;
}

@observer
export default class TxpPeekWrapper extends React.Component<TxpPeekWrapperProps> {
    private txpConfiguration: TxpConfiguration;
    private txpStyle: OwaTxpStyle;

    constructor(props: TxpPeekWrapperProps) {
        super(props);
        let {
            entityNamesMap,
            isInvoiceSupported,
            isServiceReservationSupported,
            txpLocation,
            onViewInMailClicked,
        } = this.props;

        this.txpConfiguration = createCalendarPeekTxpConfiguration(
            isInvoiceSupported,
            entityNamesMap,
            txpLocation,
            this.props.colorScheme,
            styles,
            isServiceReservationSupported,
            this.getDatapointLogger,
            onViewInMailClicked
        );

        this.onCardViewed();
    }

    public componentWillReceiveProps(newProps: TxpPeekWrapperProps) {
        if (newProps.txpLocation != this.props.txpLocation) {
            let { txpImages } = this.txpConfiguration;

            this.txpConfiguration.getLocationControl = (
                showFullAddress: boolean,
                telephone: string
            ) =>
                getTxpLocation(
                    newProps.txpLocation,
                    showFullAddress,
                    txpImages,
                    this.txpStyle,
                    telephone
                );
        }
    }

    render() {
        let { colorScheme, txpObject } = this.props;

        this.txpStyle = createCalendarPeekStyle(colorScheme, styles);

        let txpStrings = createTxpStrings();

        if (txpObject) {
            return (
                <div>
                    <Txp
                        txpObject={txpObject}
                        txpStyle={this.txpStyle}
                        txpStrings={txpStrings}
                        txpConfiguration={this.txpConfiguration}
                    />
                </div>
            );
        } else {
            return <Spinner className={styles.spinner} size={SpinnerSize.large} />;
        }
    }

    private onCardViewed = () => {
        const { datapointLogger, entityNamesMap, txpObject } = this.props;
        const internetMessageId = getInternetMessageIdFromTxpObject(txpObject);

        populateCardViewedDatapoint(
            datapointLogger,
            getOriginFromTxpObject(txpObject),
            entityNamesMap,
            internetMessageId
        );
    };

    private getDatapointLogger = (
        txpDatapoint: TxpDatapoint,
        datapointName: string,
        internetMessageId?: string
    ) => {
        const loggingInternetMessageId = getInternetMessageIdFromTxpObject(this.props.txpObject);
        this.props.datapointLogger(txpDatapoint, datapointName, loggingInternetMessageId);
    };
}
